import { buildAuthenticatedHeaders } from '@shared/utils/apiHelpers'

export const show = async (token: string, id: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}`, {
    method: 'get',
    headers: buildAuthenticatedHeaders(token),
  })
}

export const create = async (token: string, payload: object) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners`, {
    method: 'post',
    headers: buildAuthenticatedHeaders(token),
    body: JSON.stringify(payload),
  })
}

export const update = async (token: string, id: string, payload: object) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}`, {
    method: 'put',
    headers: buildAuthenticatedHeaders(token),
    body: JSON.stringify(payload),
  })
}

export const preferencesStore = async (token: string, id: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}/preferences_store`, {
    method: 'get',
    headers: buildAuthenticatedHeaders(token),
  })
}

export const updatePreferencesStore = async (token: string, id: string, payload: object) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}/preferences_store`, {
    method: 'put',
    headers: buildAuthenticatedHeaders(token),
    body: JSON.stringify(payload),
  })
}

export const products = async (token: string, id: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}/products`, {
    method: 'get',
    headers: buildAuthenticatedHeaders(token),
  })
}

export const updateLogo = async (token: string, id: string, data: object) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}/logos`, {
    method: 'put',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  })
}

export const removeLogo = async (token: string, id: string) => {
  return await fetch(`${import.meta.env.VITE_PRIVATE_API_URL}partners/${id}/logos`, {
    method: 'delete',
    headers: buildAuthenticatedHeaders(token),
  })
}
